<template>
  <div>
    <div class="act-hamb" v-if="isActiveHamburgerMenu">
      <div class="d-flex" style="height: 50px; align-items: center; ">
        <img src="/img/logo.png" style="width: 150px; height: 70px; margin-left: 16px" @click="goToHomePage" />
        <div style="
            justify-content: right;
            display: inline-flex;
            margin-right: 16px;
            width: 100%;
          ">
          <div @click="closeMenu">
            <close />
          </div>
        </div>
      </div>
      <div style="background: #f1f1f1; width: 100%; height: 1px"></div>
      <HamburgerMenu v-if="isActiveHamburgerMenu" @close="() => isActiveHamburgerMenu = false" />
    </div>
    <div class="header-menu container">
      <v-toolbar-title class="text-uppercase blue--text d-flex" style="align-items: center; width: 100%">
        <div style="cursor: pointer; margin-left: 16px; display: flex; align-items: center;" @click="goToHomePage">
          <LogoNav width="140" height="40" />
        </div>
        <div style="
            justify-content: right;
            display: inline-flex;
            margin-right: 16px;
            width: 100%;
          ">
          <img src="/img/other/ic_menu_white.png" style="width: 24px; height: 24px; cursor: pointer"
            @click="openMenu" />
        </div>
      </v-toolbar-title>
    </div>
    <div class="sub-banner font-poppins">
      <h1 class="title-banner font-poppins" v-html="$t('home.heroSection.title')">
      </h1>
      <p style="color: white; text-align: center;" v-html="$t('home.heroSection.subtitle')"></p>
      <div class="menu-flex">
        <!-- <div class="ctn" @click="goToClass">
          <PublicIc :width="70" :height="70" />
          <p class="font-poppins" style="width: 85px; height: 30px">Public Training</p>
        </div> -->
        <!-- <div class="ctn" @click="goToBootcamp">
          <BootcampIc :width="70" :height="70" />
          <p class="font-poppins" style="width: 85px; height: 30px">Bootcamp</p>
        </div>
        <div class="ctn" @click="goToCertification">
          <PraIc :width="70" :height="70" />
          <p class="font-poppins" style="width: 85px; height: 30px">Certification</p>
        </div>
        <div class="ctn" @click="goToEvent">
          <EventIc :width="70" :height="70" />
          <p class="font-poppins" style="width: 85px; height: 30px">Event</p>
        </div>
        <div class="ctn" @click="goToCorporateTraining">
          <CorpIc :width="70" :height="70" />
          <p class="font-poppins" style="width: 85px; height: 30px">Corporate</p>
        </div> -->
      </div>
    </div>
    <div class="border-banner-bottom"></div>
    <div>
      <div class="marquee-container">
        <div class="marquee-wrapper">
          <div class="our-client">
            <img v-for="(item, idx) in ourPartners" :key="idx" :src="item.img_url_mobile" class="image-client" />
          </div>
        </div>
        <div class="marquee-wrapper">
          <div class="our-client">
            <img v-for="(item, idx) in ourPartners" :key="idx" :src="item.img_url_mobile" class="image-client" />
          </div>
        </div>
      </div>
    </div>
    <div class="key-feature container">
      <div class="card-feature">
        <div class="content">
          <h2>{{ $t('home.aboutSection.title') }}</h2>
          <p>{{ $t('home.aboutSection.description') }} </p>
          <div class="list">
            <div>
              <h2>1500+</h2>
              <p>{{ $t('home.additionalInfo.0.title') }}</p>
            </div>
            <div>
              <h2>20+</h2>
              <p>{{ $t('home.additionalInfo.1.title') }}</p>
            </div>
            <div>
              <h2>16+</h2>
              <p>{{ $t('home.additionalInfo.2.title') }}</p>
            </div>
            <div>
              <h2>4.8</h2>
              <p>Google Rating</p>
            </div>
          </div>
        </div>
      </div>
      <iframe class="card-image" src="https://www.youtube.com/embed/7mBp0DYzql4?si=O6Aw9SheRYdJm3a2"
        title="YouTube video player" frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
    </div>
    <div class="unique-selling-proposition">
      <div class="unique-selling-proposition-container">
        <h2 class="text-center poppins-font usp-title">
          {{ $t('home.uspSection.title') }}
        </h2>
        <div class="content">
          <div class="card text-start" v-for="(item, idx) in $t('home.usps')" :key="idx">
            <img :src="item.img" alt="" width="60" height="60" />
            <div class="label">
              <p class="sub-title">{{ item.name }}</p>
              <p class="description">
                {{ item.description }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container usp">
      <h2 class="text-center">{{ $t('home.usp2Section.title') }}</h2>
      <div class="card-img">
        <img src="/img/corporate/collaboration/training.png" alt="" />
      </div>
      <div class="card-usp" v-for="(usp, index) in $t('home.usps2')" :key="index">
        <div class="title-container mb-2">
          <div style="width: 30px; height: 30px">
            <component :is="usp.image"></component>
          </div>
          <div>
            <h3>{{ usp.title }}</h3>
            <p>{{ usp.desc }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="container" style="margin-top: -70px;">
      <BannerMobile :banners="banners" />
    </div>
    <div class="list-of-acceleration" style="background-color: white;">
      <div class="list-of-acceleration-container">
        <h2 class="text-center my-1">{{ $t('home.accelerationProgramSection.title') }}</h2>
        <div class="nav-container">
          <button v-for="(tab, index) in tabs" :key="index" :class="`tab-btn ${activeTab === tab ? 'active' : ''}`"
            @click="setActiveTab(tab)">
            {{ tab }}
          </button>
        </div>
        <div class="card" style="padding-bottom: 60px">
          <div class="items" v-for="(item, idx) in listClass" :key="idx" @click="directDetail(item.slug_name)"
            :title="item.name">
            <div style="height: 160px">
              <img :src="item.small_image_url" alt="" style="width: 100%; height: 100%; border-radius: 20px 20px 0 0" />
            </div>
            <div class="label" v-if="item.collaboration_feed">
              <img :src="item.collaboration_feed" alt="" style="width: 80%" />
            </div>
            <div class="content">
              <div style="height: 60px;">
                <h2>{{ item.name }}</h2>
              </div>
              <div class="category">
                <div style="background-color: #f1f6ff" v-if="item.level">
                  <p>{{ item.level }}</p>
                </div>
              </div>
              <div class="event-ctn-info my-2" v-if="item.session">
                <NoteIcon :width="25" fill="#575966" />
                <span class="name">{{ item.session }} {{ $t('home.a2') }}</span>
              </div>
              <div class="event-ctn-info my-2" v-if="activeTab != 'Event'">
                <AwardIcon :width="25" fill="#575966" />
                <span class="name">Reguler / Private</span>
              </div>
              <div class="event-ctn-info" v-if="item.days">
                <DateIcon :width="22" fill="#575966" />
                <span class="name">{{ item.days }}</span>
              </div>
              <div class="event-ctn-info" v-if="item.hours">
                <clock :width="22" fill="#575966" />
                <span class="name">{{ item.hours }}</span>
              </div>
              <div class="event-ctn-info" v-if="item.method">
                <methode :width="22" fill="#575966" />
                <span class="name">{{ item.method | toMethode }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="btn-stoke-blue" @click="directOther">
          <span class="font-poppins">{{ $t('home.a1') }}</span>
          <ArrowLong />
        </div>
      </div>
    </div>
    <div class="list Of-acceleration" style="background-color: #F1F6FF; padding: 40px 0; border-radius: 32px;">
      <div class="list-of-acceleration-container">
        <p class="margin-0" style="font-weight: 500; color: #36373F; font-size: 16px;">{{
          $t('home.accelerationPrograms.corporateServiceSection.title') }}</p>
        <h2 style="text-align: left; margin-top: -12px;">{{
          $t('home.accelerationPrograms.corporateServiceSection.subtitle') }}</h2>
        <p class="margin-0"
          style="font-weight: 400; margin-top: -18px; margin-bottom: 32px; color: #36373F; font-size: 15px;">{{
            $t('home.accelerationPrograms.corporateServiceSection.description') }}</p>
        <div class="card-1" v-for="(item, idx) in $t('home.descs1')" :key="idx">
          <img :src="item.img" class="img-2" />
          <div>
            <h3>{{ item.title }}</h3>
            <p>{{ item.desc }}</p>
          </div>
        </div>
        <div class="btn-stoke-blue" style="margin-top: 40px; background-color: #162CA2; color: white;"
          @click="$router.push('/corporate')">
          <span class="font-poppins">{{ $t('home.a1') }}</span>
          <ArrowLong fill="#FFFFFF" />
        </div>
      </div>
    </div>
    <div class="list-of-acceleration" style="background-color: white; padding: 40px 0;">
      <div class="list-of-acceleration-container">
        <h2 style="text-align: left; margin-top: -12px;">{{ $t('home.accelerationPrograms.testimonySection.subtitle') }}
        </h2>
        <div class="card-2" v-for="(item, idx) in testimonies" :key="idx">
          <p class="text-center">"{{ item.feedback }}"</p>
          <div class="profile mt-5 d-flex" style="display: flex;">
            <div class="avatar">
              <v-img :src="$utils.loadImage(item.image_url)" alt="" width="56" height="56" class="avatar-image" />
            </div>
            <div class="testi-profile ml-5">
              <div class="name">{{ item.name }}</div>
              <div class="description">
                {{ item.job }}
              </div>
              <div class="description">
                {{ item.place }}
              </div>
              <v-img v-if="item.linkedin" src="/img/home/linkedin.png" alt="" width="24" height="24"
                @click="redirectReload(item.linkedin)" class="linkedin-image cursor-pointer" />
            </div>
          </div>
        </div>
        <div class="btn-stoke-blue" style="margin-top: 40px; background-color: white;"
          @click="$router.push('/testimony')">
          <span class="font-poppins">{{ $t('home.a1') }}</span>
          <ArrowLong />
        </div>
      </div>
    </div>
    <div class="faqbg">
      <div class="faq">
        <h1>Frequently Asked Question</h1>
        <div class="container">
          <AccordeonFaq v-for="(item, index) in questions" :key="index" :title="item.title"
            :description="item.description" :active="item.active" @toggle="toggleAccordion(index)" />
          <div class="btn-stoke-blue cursor-pointer" @click="$router.push('/faq')"
            style="background-color: white; margin-top: 30px;">
            <span class="font-poppins">{{ $t('home.a1') }}</span>
            <ArrowLong />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import goTo from 'vuetify/lib/services/goto';
import HamburgerMenu from '@/components/HamburgerMenu';
import LogoNav from '@/assets/icons/LogoNav.vue';
import BannerMobile from '../BannerMobile.vue';
import DateIc2 from '../icons/Date.vue';
import ArrowLong from '@/assets/icons/ArrowLong.vue';
import Clock from '../icons/Clock.vue';
import DateIcon from '../icons/Date.vue';
import Speaker from '../icons/Speaker.vue';
import Methode from '../icons/Methode.vue';
import People from '../icons/People.vue';
import Button from '../../others/Button.vue';
import AccordeonFaq from '@/components/AccordeonFaq.vue';
import BootcampIc from '../icons/BootcampIc.vue';
import PublicIc from '../icons/Public.vue';
import CorpIc from '../icons/CorpIc.vue';
import PraIc from '../icons/PraIc.vue';
import EventIc from '../icons/Event.vue';
import Heart from '../icons/Heart.vue';
import Skill from '../icons/Skill.vue';
import Lamp from '../icons/Lamp.vue';
import NoteIcon from '@/assets/icons/Note.vue';
import AwardIcon from '@/assets/icons/Award.vue';
import Close from '@/assets/icons/Close.vue';

export default {
  components: {
    Close,
    NoteIcon,
    AwardIcon,
    Heart,
    Skill,
    Lamp,
    ArrowLong,
    LogoNav,
    Button,
    BootcampIc,
    PublicIc,
    CorpIc,
    PraIc,
    EventIc,
    DateIc2,
    BannerMobile,
    HamburgerMenu,
    DateIcon,
    Clock,
    Methode,
    Speaker,
    People,
    AccordeonFaq,
  },
  data() {
    return {
      mobileView: false,
      is_login_show: false,
      isActiveHamburgerMenu: false,
      questions: [],
      testimonies: [],
      accelerations: [],
      ourPartners: [],
      events: [],
      banners: [],
      bootcampClass: [],
      listClass: [],
      duration: 300,
      offset: 0,
      easing: 'easeInOutCubic',
      tabs: ['Public Training', 'Bootcamp', 'Certification', 'Event'],
      activeTab: 'Public Training',
    };
  },
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0;
    if (to.hash) {
      scrollTo = to.hash;
    } else if (savedPosition) {
      scrollTo = savedPosition.y;
    }
    return goTo(scrollTo);
  },
  computed: {
    options() {
      return {
        duration: this.duration,
        offset: this.offset,
        easing: this.easing,
      };
    },
  },
  watch: {
    '$i18n.locale'() {
      this.setActiveTab(this.activeTab);
      this.getFaq();
      this.getTestimoni();
    },
  },
  methods: {
    setActiveTab(tab) {
      this.activeTab = tab;
      this.$gtag.event('click', {
        event_category: 'Tab',
        event_label: `Tab - ${tab}`,
        value: 1,
      });
      if (tab === 'Public Training') {
        this.getPublicClass();
      } else if (tab === 'Bootcamp') {
        this.getBootcampClass();
      } else if (tab === 'Certification') {
        this.getAccelerationClass();
      } else if (tab === 'Prakerja') {
        this.getPrakerjaClass();
      } else {
        this.getDataEvents();
      }
    },
    directDetail(slugName) {
      const item = this.listClass.find(item => item.slug_name === slugName);
      if (item) {
        this.$gtag.event('view_item', {
          event_category: 'E-commerce',
          event_label: item.name,
          value: item.price || 0,
          items: [
            {
              item_id: item.slug_name,
              item_name: item.name,
              item_category: this.activeTab,
              price: item.price || 0,
              quantity: 1,
            },
          ],
        });
      }
      if (this.activeTab === 'Public Training') {
        this.$router.push(`/class/public-training/detail/${slugName}`);
      } else if (this.activeTab === 'Bootcamp') {
        this.$router.push(`/class/bootcamp/${slugName}`);
      } else if (this.activeTab === 'Certification') {
        this.$router.push(`/certification/detail/${slugName}`);
      } else if (this.activeTab === 'Prakerja') {
        this.$router.push(`/class/prakerja/${slugName}`);
      } else {
        this.$router.push(`/event/detail/${slugName}`);
      }
    },
    directOther() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: `${this.activeTab} See More Button`,
        value: 1,
      });
      if (this.activeTab === 'Public Training') {
        this.$router.push('/class/public-training');
      } else if (this.activeTab === 'Bootcamp') {
        this.$router.push('/class/bootcamp');
      } else if (this.activeTab === 'Certification') {
        this.$router.push('/certification');
      } else if (this.activeTab === 'Prakerja') {
        this.$router.push('/prakerja');
      } else {
        this.$router.push('/event');
      }
    },
    openMenu() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Open Hamburger Menu',
        value: 1,
      });
      this.isActiveHamburgerMenu = true;
    },
    closeMenu() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Close Hamburger Menu',
        value: 1,
      });
      this.isActiveHamburgerMenu = false;
    },
    goToCustomerService() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Customer Service WhatsApp',
        value: 1,
      });
      window.location.href =
        'https://api.whatsapp.com/send/?phone=6282127274632&text=Hi Kak HiColleagues, saya mau bertanya';
    },
    async getTestimoni() {
      try {
        const resp = await this.$http.get(`/v1/testimony?category=HOME&page=1&per_page=4`);
        this.testimonies = resp.data.data.testimonies;
      } catch (err) {
        console.log(err);
      }
    },
    toggleAccordion(index) {
      this.$gtag.event('click', {
        event_category: 'FAQ',
        event_label: `FAQ - ${this.questions[index].title}`,
        value: 1,
      });
      this.questions[index].active = !this.questions[index].active;
    },
    async getFaq() {
      this.questions = [];
      try {
        const resp = await this.$http.get(`/v1/faq?category=HOME&is_main=true`);
        this.questions = resp.data.data.faq.map((item) => ({
          description: item.answer[0],
          title: item.question,
          active: false,
        }));
      } catch (err) {
        console.log(err);
      }
    },
    async getBanners() {
      await this.$http
        .get('/v1/banner?category=GENERAL&is_active=true')
        .then((response) => {
          this.banners = response.data.data.banners;
        })
        .catch((err) => console.error(err.response));
    },
    async getClientLogo() {
      try {
        const resp = await this.$http.get('/v1/logo?category=CORPORATE');
        this.ourPartners = resp.data.data.logos;
      } catch (err) {
        console.log(err);
      }
    },
    async getBootcampClass() {
      try {
        const resp = await this.$http.get(`/v1/class/category/5?is_main=true`);
        this.listClass = resp.data.data.classes;
      } catch (err) {
        console.log(err);
      }
    },
    async getPublicClass() {
      try {
        const resp = await this.$http.get(`/v1/class/category/1?is_main=true`);
        this.listClass = resp.data.data.classes;
      } catch (err) {
        console.log(err);
      }
    },
    async getPrakerjaClass() {
      try {
        const resp = await this.$http.get(`/v1/class/category/4?is_main=true`);
        this.prakerjaClass = resp.data.data.classes;
      } catch (err) {
        console.log(err);
      }
    },
    async getAccelerationClass() {
      try {
        const resp = await this.$http.get(`/v1/class/category/6?is_main=true`);
        this.listClass = resp.data.data.classes;
      } catch (err) {
        console.log(err);
      }
    },
    async getDataEvents() {
      try {
        const resp = await this.$http.get(`/v1/event?is_active=true`);
        this.listClass = resp.data.data.events.map((item) => ({
          ...item,
          small_image_url: item.img_urls.mobile.thumbnail,
          session: item.total_session,
          days: '',
          hours: `${item.session_schedules[0].start_time} - ${item.session_schedules[0].end_time} WIB`,
        }));
      } catch (err) {
        console.log(err);
      }
    },
    goToHomePage() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Home Page',
        value: 1,
      });
      this.$router.push({ path: '/' }).then(() => {
        this.$router.go();
      });
    },
    goToClass() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Public Training Button',
        value: 1,
      });
      this.$router.push({ path: '/class/public-training' }).then(() => {
        this.$router.go();
      });
    },
    goToKampusMerdeka() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Kampus Merdeka',
        value: 1,
      });
      this.$router.push({ path: '/kampusmerdeka' }).then(() => {
        this.$router.go();
      });
    },
    goToEvent() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Event Button',
        value: 1,
      });
      this.$router.push({ path: '/event' }).then(() => {
        this.$router.go();
      });
    },
    goToCertification() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Certification Button',
        value: 1,
      });
      this.$router.push({ path: '/certification' }).then(() => {
        this.$router.go();
      });
    },
    goToCorporateTraining() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Corporate Training Button',
        value: 1,
      });
      this.$router.push('/corporate/training');
    },
    goToBootcamp() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Bootcamp Button',
        value: 1,
      });
      this.$router.push({ path: '/class/bootcamp' }).then(() => {
        this.$router.go();
      });
    },
    goToTalentAsAService() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Talent as a Service',
        value: 1,
      });
      this.$router.push({ path: '/talent-service' }).then(() => {
        this.$router.go();
      });
    },
    goToClassBootcamp(slug_name) {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: `Class Bootcamp - ${slug_name}`,
        value: 1,
      });
      this.$router.push('/class/public-training/detail/' + slug_name);
      sessionStorage.setItem('nav-item-active', 0);
      window.location.reload();
    },
    toDiscount(item) {
      const total_price = item.price - item.discount;
      if (total_price <= 0) {
        return 'FREE';
      } else {
        var formatter = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'IDR',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        });
        return formatter.format(total_price);
      }
    },
    redirectReload(e) {
      if (e.slice(0, 5) == 'https') {
        this.$gtag.event('click', {
          event_category: 'Social Media',
          event_label: `LinkedIn Testimony - ${e}`,
          value: 1,
        });
        window.open(e, '_blank');
      } else {
        this.$gtag.event('click', {
          event_category: 'Navigation',
          event_label: `Router - ${e}`,
          value: 1,
        });
        this.$router.push({ path: e }).then(() => {
          this.$router.go();
        });
      }
    },
    toMethode(value) {
      if (!value) return;
      if (value.toLowerCase() === 'online') {
        return 'Daring';
      } else if (value.toLowerCase() === 'offline') {
        return 'Luring';
      } else {
        return value;
      }
    },
    toDetailPrakerja(item) {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: `Prakerja Detail - ${item.slug_name}`,
        value: 1,
      });
      this.$router.push('/class/prakerja/' + item.slug_name);
    },
    discountPercent(event) {
      return Math.round(((event.price - (event.price - event.discount_price)) / event.price) * 100);
    },
    countDownTimer() {
      const _second = 1000;
      const _minute = _second * 60;
      const _hour = _minute * 60;
      const _day = _hour * 24;
      let days, hours, minutes, seconds;
      const showRemaining = () => {
        this.events.forEach((item2) => {
          const end = new Date(item2.registration_close_date);
          const now = new Date();
          const distance = end - now;
          if (distance < 0) {
            item2.expired = [];
            return;
          }
          days = Math.floor(distance / _day);
          hours = Math.floor((distance % _day) / _hour);
          minutes = Math.floor((distance % _hour) / _minute);
          seconds = Math.floor((distance % _minute) / _second);
          item2.expired = [days, hours, minutes, seconds];
        });
      };
      setInterval(showRemaining, 1000);
    },
    checkIsEarlyBird(item) {
      if (new Date(item.start_discount_date) <= new Date() && new Date(item.end_discount_date) >= new Date()) {
        return true;
      } else {
        return false;
      }
    },
    moment(date, val) {
      if (!val) {
        return moment(date).format('dddd, DD MMMM YYYY');
      }
      return moment(date).format(val);
    },
    async getTotalRegistran(id) {
      try {
        const resp = await this.$http.get(`/v1/event/${id}/registrant`);
        return resp.data.data.total_registrants;
      } catch (error) {
        console.log(error);
        return 0;
      }
    },
    async toCheckoutPrakerja(data) {
      try {
        const response = await this.$http.get(`/v1/class-detail/${data.slug_name}`);
        const classDetail = response.data.data.class_detail;

        this.$gtag.event('add_to_cart', {
          event_category: 'E-commerce',
          event_label: classDetail.name,
          value: classDetail.price || 0,
          items: [
            {
              item_id: classDetail.class_id,
              item_name: classDetail.name,
              item_category: classDetail.category_id,
              price: classDetail.price || 0,
              quantity: 1,
            },
          ],
        });

        const reqCheckout = JSON.stringify({
          class_id: classDetail.class_id,
          class_name: classDetail.name,
          price: classDetail.price,
          level: classDetail.level,
          session: classDetail.session_total,
          hour: classDetail.hours,
          image_url: classDetail.small_image_url,
          class_type: 'PRAKERJA_CLASS',
          days: classDetail.days,
          methode: classDetail.method,
          category_id: classDetail.category_id,
        });

        localStorage.clear();
        localStorage.setItem('checkout', reqCheckout);
        window.location.href = '/checkout';
      } catch (err) {
        console.error(err.response);
      }
    },
    toDetail(item) {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: `Event Detail - ${item.slug_name}`,
        value: 1,
      });
      this.$router.push('/event/detail/' + item.slug_name);
    },
    async toCheckout(item) {
      const total_registrants = await this.getTotalRegistran(item.id);
      if (total_registrants >= item.participant_quota && item.participant_quota !== 0) {
        this.notif.isAlertErr = true;
        this.notif.alertErrMessage = 'Kouta pendaftaran sudah penuh';
        return;
      }
      this.$gtag.event('add_to_cart', {
        event_category: 'E-commerce',
        event_label: item.name,
        value: item.price || 0,
        items: [
          {
            item_id: item.id,
            item_name: item.name,
            item_category: 'Event',
            price: item.price || 0,
            quantity: 1,
          },
        ],
      });
      this.$router.push('/checkout/event/' + item.slug_name);
    },
    toCurrency(value) {
      if (typeof value !== 'number') {
        return value;
      }
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'IDR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
      return formatter.format(value);
    },
  },
  mounted() {
    this.getBanners();
    this.getPublicClass();
    this.getClientLogo();
    this.getFaq();
    this.countDownTimer();
    this.getTestimoni();
  },
};
</script>

<style src="./home.css" scoped></style>